// src/components/SimpleInput.tsx
import React from "react";
import { Input } from "tvs-unified-lib";

interface SimpleInputProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  required: boolean;
}
export default function SimpleInput({
  value = "",
  onChange,
  placeholder,
  disabled,
  required = false,
}: SimpleInputProps) {
  return (
    <Input
      name="simple"
      value={value}
      placeholder={placeholder}
      onInputChange={(e: any) => onChange(e.target.value)}
      disabled={disabled}
      isRequired={required}
    />
  );
}
